import apiEndPoints from '../../utils/apiEndPoints'
import { apiCall } from '../../utils/httpClient';

const getMasterList = async (params) => {
    const data = await apiCall("post", apiEndPoints.ADDMASTERLIST, params);
        return data;
};
const createMaster = async (params) => {
    const data = await apiCall("post", apiEndPoints.CREATEMASTER, params);
        return data;
};
const getCityList = async (params) => {
    const data = await apiCall("post", apiEndPoints.GETCITYLIST, params);
        return data;
};

const userService = {
    getMasterList,
    createMaster,
    getCityList
  };
  
  export default userService;

